<template>
	<!--
<AreaInput
	:min="filterAdvTemp.estimateInstalledCapacityMin" @Min="filterAdvTemp.estimateInstalledCapacityMin=arguments[0]"
	:max="filterAdvTemp.estimateInstalledCapacityMax" @Max="filterAdvTemp.estimateInstalledCapacityMax=arguments[0]"
	:list="[
		{text:'&lt;50'+$t('unit39',['m²']),min:'',max:50},
		{text:'50~100'+$t('unit39',['m²']),min:50,max:100},
		{text:'100~150'+$t('unit39',['m²']),min:100,max:150},
		{text:'150~200'+$t('unit39',['m²']),min:150,max:200},
		{text:'&gt;200'+$t('unit39',['m²']),min:200,max:''}
	]"
	:size="'m'"
></AreaInput>
-->
	<div class="dpIB_E">
		<InputText
			v-if="mode == 'number'"
			name="numberiMin"
			:class="inputWidth"
			:size="size"
			v-model="iMin"
			@Blur="validValue"
			:maxLength="4"
			:only="'int'"
			:placeholder="$t('word278', ['最小值'])"
		></InputText>
		<vue-datepicker-local
			v-if="mode == 'time'"
			v-model="iMin"
			:class="returnSize"
			:format="timeFormat"
			:disabled-date="disabledDate"
			clearable
		></vue-datepicker-local>
		<span v-if="unit">{{ unit }}</span>
		<span>~</span>
		<InputText
			v-if="mode == 'number'"
			name="numberiMax"
			class="mr05x"
			:class="inputWidth"
			:size="size"
			v-model="iMax"
			@Blur="validValue"
			:maxLength="4"
			:only="'int'"
			:placeholder="$t('word279', ['最大值'])"
		></InputText>
		<vue-datepicker-local
			v-if="mode == 'time'"
			v-model="iMax"
			:class="returnSize"
			:format="timeFormat"
			:disabled-date="disabledDate"
			clearable
		></vue-datepicker-local>
		<span v-if="unit">{{ unit }}</span>
		<button
			:key="index"
			v-for="(li, index) in list"
			class="mr05x bdSub boxR cSub pl05x pr05x hover-bd-main"
			:class="sizeClass"
			@click="setArea(li.min, li.max)"
		>
			{{ li.text }}
		</button>
	</div>
</template>
<script>
import { timeFormat, fill2str } from "@/util/lib.js";

export default {
	components: {  },
	props: {
		min: {
			// type:String,
			default: "",
		},
		max: {
			// type:String,
			default: "",
		},
		list: {
			type: Array,
			default: () => [],
		},
		size: {
			type: String,
			default: "m",
		},
		mode: {
			//区间模式：“number”：数字区间、“time”：时间区间
			type: String,
			default: "number",
		},
		unit: {
			type: String,
			default: null,
		},
		disableTime: {
			type: Array,
			default: () => ["", ""],
		},
		timeFormat: {
			type: String,
			default: "YYYY/MM/DD",
		},
		areaFix: {
			//是否进行超限修正数据
			type: Boolean,
			default: true,
		},
		inputWidth: {
			type: String,
			default: "w7x",
		},
	},
	data() {
		return {
			iMin: this.min,
			iMax: this.max,
		};
	},
	watch: {
		min(val) {
			if (String(val) != String(this.iMin)) {
				//防止无限执行
				this.$set(this, "iMin", val);
			}
		},
		max(val) {
			if (String(val) != String(this.iMax)) {
				//防止无限执行
				this.$set(this, "iMax", val);
			}
		},
		iMin(val) {
			if (this.areaFix && val && this.mode == "time") {
				let date = new Date(val);
				// let utc=Date.parse(date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate()+" 00:00:00");
				val = new Date(date);
				if (Date.parse(val) > Date.parse(this.iMax) && this.iMax) {
					//判断数据合理性
					val = Date.parse(new Date(this.iMax)) - 1000;
					this.$nextTick(function () {
						//确保数据反馈在界面上
						this.$set(this, "iMin", val);
					});
				}
			}
			this.$emit("Min", val, this.iMax);
		},
		iMax(val) {
			if (this.areaFix && val && this.mode == "time") {
				let date = new Date(val);
				// let utc=Date.parse(date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate()+" "+timeFormat(23*60*60*1000+59*60*1000+59*1000+999,"utc","%H:%M:%S"));
				// let utc=Date.UTC(date.getFullYear(),date.getMonth(),date.getDate(),23,59,59,999);
				val = new Date(date);
				if (Date.parse(val) < Date.parse(this.iMin) && this.iMin) {
					//判断数据合理性
					val = Date.parse(new Date(this.iMin)) + 1000;
					this.$nextTick(function () {
						//确保数据反馈在界面上
						this.$set(this, "iMax", val);
					});
				}
			}
			this.$emit("Max", val, this.iMin);
		},
	},
	computed: {
		returnSize: function () {
			let style = "";
			switch (this.size) {
				case "s":
					style = "sizeS";
					break;
				case "m":
					style = "sizeM";
					break;
				case "l":
					style = "sizeL";
					break;
			}
			return style;
		},
	},
	methods: {
		setArea: function (min, max) {
			this.iMin = min;
			this.iMax = max;
		},
		disabledDate(time, format) {
			let day = time.getTime();
			if (this.min) {
				let lastDay = _.cloneDeep(this.min);
				if (this.disableTime[1] == "day") {
					return day > lastDay.setDate(lastDay.getDate() + Number(this.disableTime[0]) - 1);
				} else if (this.disableTime[1] == "month") {
					return day > lastDay.setMonth(lastDay.getMonth() + Number(this.disableTime[0]));
				} else if (this.disableTime[1] == "now") {
					return this.disableTime[0].getTime() > day;
				}
			}
			return false;
		},
		validValue: function () {
			if (this.iMin && this.iMax) {
				let min = Number(this.iMin);
				let max = Number(this.iMax);
				if (min > max) {
					min = max;
					this.$nextTick(function () {
						this.$set(this, "iMin", min);
						this.$emit("Min", min, max);
					});
				} else if (max < min) {
					max = min;
					this.$nextTick(function () {
						this.$set(this, "iMax", max);
						this.$emit("Max", max, min);
					});
				}
			}
		},
	},
	mounted() {
		// trace(this.list,true)
	},
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/ui/AreaInput.vue